import { withJsonFormsControlProps } from '@jsonforms/react'

import {
  PageAutocompleteSystem,
  autocompleteTester,
} from '../element/Autocomplete'
import { PageCheckboxSystem, checkboxTester } from '../element/Checkbox'
import {
  PageCheckboxGroupSystem,
  checkboxGroupTester,
} from '../element/CheckboxGroup'
import {
  PageCheckboxInputSystem,
  checkboxInputTester,
} from '../element/CheckboxInput'
import { PageDateSystem, dateTester } from '../element/Date'
import { PageDateTimeSystem, dateTimeTester } from '../element/DateTime'
import { PageInputSystem, inputTester } from '../element/Input'
import {
  PageInputSearchSystem,
  inputSearchTester,
} from '../element/InputSearch'
import { PageInputMaskSystem, inputMaskTester } from '../element/InputMask'
import { PageNumberSystem, numberTester } from '../element/Number'
import { PageRadioSystem, radioTester } from '../element/Radio'
import { PageSelectSystem, selectTester } from '../element/Select'
import { PageTableSystem, tableTester } from '../element/Table'
import { PageCustomTableSystem, customTableTester } from '../element/CustomTable'
import { PageTextareaSystem, textareaTester } from '../element/Textarea'
import { PageTimeSystem, timeTester } from '../element/Time'

import { RichTextSystem, richTextTester } from '../element/RichText'
import {
  ButtonSystem,
  ButtonDropdownSystem,
  buttonTester,
  buttonDropdownTester,
} from '../element/Button'
import {
  FavoriteButtonSystem,
  favoriteButtonTester,
} from '../element/FavoriteButton'
import { DividerSystem, dividerTester } from '../element/Divider'
import { ElementSystem, elementTester } from '../element/Element'
import { FileUploadSystem, fileUploadTester } from '../element/FileUpload'
import { ImageSystem, imageTester } from '../element/Image'
import { ImageCropperSystem, imageCropperTester } from '../element/ImageCropper'
import { ImageWebcamSystem, imageWebcamTester } from '../element/ImageWebcam'
import { VideoSystem, videoTester } from '../element/Video'
import { VideoWebcamSystem, videoWebcamTester } from '../element/VideoWebcam'
import { BadgeSystem, badgeTester } from '../element/Badge'
import { ScoreChartSystem, scoreChartTester } from '../element/ScoreChart'
import { LabelSystem, labelTester } from '../element/Label'
import { GallerySystem, galleryTester } from '../element/Gallery'
import { ListSystem, listTester } from '../element/List'
import { ColorPickerSystem, colorPickerTester } from '../element/ColorPicker'

const formElement = [
  {
    tester: richTextTester,
    renderer: withJsonFormsControlProps(RichTextSystem),
  },
  {
    tester: buttonTester,
    renderer: withJsonFormsControlProps(ButtonSystem),
  },
  {
    tester: buttonDropdownTester,
    renderer: withJsonFormsControlProps(ButtonDropdownSystem),
  },
  {
    tester: favoriteButtonTester,
    renderer: withJsonFormsControlProps(FavoriteButtonSystem),
  },
  {
    tester: dividerTester,
    renderer: withJsonFormsControlProps(DividerSystem),
  },
  {
    tester: elementTester,
    renderer: withJsonFormsControlProps(ElementSystem),
  },
  {
    tester: fileUploadTester,
    renderer: withJsonFormsControlProps(FileUploadSystem),
  },
  {
    tester: imageTester,
    renderer: withJsonFormsControlProps(ImageSystem),
  },
  {
    tester: imageCropperTester,
    renderer: withJsonFormsControlProps(ImageCropperSystem),
  },
  {
    tester: imageWebcamTester,
    renderer: withJsonFormsControlProps(ImageWebcamSystem),
  },
  {
    tester: videoTester,
    renderer: withJsonFormsControlProps(VideoSystem),
  },
  {
    tester: videoWebcamTester,
    renderer: withJsonFormsControlProps(VideoWebcamSystem),
  },
]

const defaultElement = [
  {
    tester: autocompleteTester,
    renderer: withJsonFormsControlProps(PageAutocompleteSystem),
  },
  {
    tester: checkboxTester,
    renderer: withJsonFormsControlProps(PageCheckboxSystem),
  },
  {
    tester: checkboxGroupTester,
    renderer: withJsonFormsControlProps(PageCheckboxGroupSystem),
  },
  {
    tester: checkboxInputTester,
    renderer: withJsonFormsControlProps(PageCheckboxInputSystem),
  },
  {
    tester: dateTester,
    renderer: withJsonFormsControlProps(PageDateSystem),
  },
  {
    tester: dateTimeTester,
    renderer: withJsonFormsControlProps(PageDateTimeSystem),
  },
  {
    tester: inputTester,
    renderer: withJsonFormsControlProps(PageInputSystem),
  },
  {
    tester: inputSearchTester,
    renderer: withJsonFormsControlProps(PageInputSearchSystem),
  },
  {
    tester: inputMaskTester,
    renderer: withJsonFormsControlProps(PageInputMaskSystem),
  },
  {
    tester: numberTester,
    renderer: withJsonFormsControlProps(PageNumberSystem),
  },
  {
    tester: radioTester,
    renderer: withJsonFormsControlProps(PageRadioSystem),
  },
  {
    tester: selectTester,
    renderer: withJsonFormsControlProps(PageSelectSystem),
  },
  {
    tester: textareaTester,
    renderer: withJsonFormsControlProps(PageTextareaSystem),
  },
  {
    tester: timeTester,
    renderer: withJsonFormsControlProps(PageTimeSystem),
  },
  {
    tester: tableTester,
    renderer: withJsonFormsControlProps(PageTableSystem),
  },
  {
    tester: customTableTester,
    renderer: withJsonFormsControlProps(PageCustomTableSystem),
  },
  {
    tester: badgeTester,
    renderer: withJsonFormsControlProps(BadgeSystem),
  },
  {
    tester: scoreChartTester,
    renderer: withJsonFormsControlProps(ScoreChartSystem),
  },
  {
    tester: labelTester,
    renderer: withJsonFormsControlProps(LabelSystem),
  },
  {
    tester: listTester,
    renderer: withJsonFormsControlProps(ListSystem),
  },
  {
    tester: colorPickerTester,
    renderer: withJsonFormsControlProps(ColorPickerSystem),
  },
]

export const pageElementSystem = [...defaultElement, ...formElement]

export const elementSystemRenderer = {
  autocomplete: {
    tester: autocompleteTester,
    renderer: withJsonFormsControlProps(PageAutocompleteSystem),
  },
  checkbox: {
    tester: checkboxTester,
    renderer: withJsonFormsControlProps(PageCheckboxSystem),
  },
  checkboxGroup: {
    tester: checkboxGroupTester,
    renderer: withJsonFormsControlProps(PageCheckboxGroupSystem),
  },
  checkboxInput: {
    tester: checkboxInputTester,
    renderer: withJsonFormsControlProps(PageCheckboxInputSystem),
  },
  date: {
    tester: dateTester,
    renderer: withJsonFormsControlProps(PageDateSystem),
  },
  dateTime: {
    tester: dateTimeTester,
    renderer: withJsonFormsControlProps(PageDateTimeSystem),
  },
  input: {
    tester: inputTester,
    renderer: withJsonFormsControlProps(PageInputSystem),
  },
  inputSearch: {
    tester: inputSearchTester,
    renderer: withJsonFormsControlProps(PageInputSearchSystem),
  },
  inputMask: {
    tester: inputMaskTester,
    renderer: withJsonFormsControlProps(PageInputMaskSystem),
  },
  number: {
    tester: numberTester,
    renderer: withJsonFormsControlProps(PageNumberSystem),
  },
  radio: {
    tester: radioTester,
    renderer: withJsonFormsControlProps(PageRadioSystem),
  },
  select: {
    tester: selectTester,
    renderer: withJsonFormsControlProps(PageSelectSystem),
  },
  textarea: {
    tester: textareaTester,
    renderer: withJsonFormsControlProps(PageTextareaSystem),
  },
  time: {
    tester: timeTester,
    renderer: withJsonFormsControlProps(PageTimeSystem),
  },
  table: {
    tester: tableTester,
    renderer: withJsonFormsControlProps(PageTableSystem),
  },
  customTable: {
    tester: customTableTester,
    renderer: withJsonFormsControlProps(PageCustomTableSystem),
  },
  richtext: {
    tester: richTextTester,
    renderer: withJsonFormsControlProps(RichTextSystem),
  },
  button: {
    tester: buttonTester,
    renderer: withJsonFormsControlProps(ButtonSystem),
  },
  buttonDropdown: {
    tester: buttonDropdownTester,
    renderer: withJsonFormsControlProps(ButtonDropdownSystem),
  },
  favoriteButton: {
    tester: favoriteButtonTester,
    renderer: withJsonFormsControlProps(FavoriteButtonSystem),
  },
  divider: {
    tester: dividerTester,
    renderer: withJsonFormsControlProps(DividerSystem),
  },
  element: {
    tester: elementTester,
    renderer: withJsonFormsControlProps(ElementSystem),
  },
  fileUpload: {
    tester: fileUploadTester,
    renderer: withJsonFormsControlProps(FileUploadSystem),
  },
  image: {
    tester: imageTester,
    renderer: withJsonFormsControlProps(ImageSystem),
  },
  imageCropper: {
    tester: imageCropperTester,
    renderer: withJsonFormsControlProps(ImageCropperSystem),
  },
  imageWebcam: {
    tester: imageWebcamTester,
    renderer: withJsonFormsControlProps(ImageWebcamSystem),
  },
  video: {
    tester: videoTester,
    renderer: withJsonFormsControlProps(VideoSystem),
  },
  videoWebcam: {
    tester: videoWebcamTester,
    renderer: withJsonFormsControlProps(VideoWebcamSystem),
  },
  badge: {
    tester: badgeTester,
    renderer: withJsonFormsControlProps(BadgeSystem),
  },
  scoreChart: {
    tester: scoreChartTester,
    renderer: withJsonFormsControlProps(ScoreChartSystem),
  },
  label: {
    tester: labelTester,
    renderer: withJsonFormsControlProps(LabelSystem),
  },
  gallery: {
    tester: galleryTester,
    renderer: withJsonFormsControlProps(GallerySystem),
  },
  list: {
    tester: listTester,
    renderer: withJsonFormsControlProps(ListSystem),
  },
  colorPicker: {
    tester: colorPickerTester,
    renderer: withJsonFormsControlProps(ColorPickerSystem),
  },
}
